import { Card, Row, Col } from 'react-bootstrap';
import { useState, useMemo } from 'react';
import OAButton from '../../../components/widgets/OAButton';
import OAModalComponent from '../../../components/OAModalComponent';
import AddTopupForm from '../Create/AddTopupForm';
import { getFormattedDate } from '../../../helper';
import { OA_DATE_TIME_FORMAT_FE } from '../../../constants';

interface ICustomerLedgerCards {
  data: any;
  onTopupSuccess?: () => void;
}

const CustomerLedgerCards = (props: ICustomerLedgerCards) => {
  const [isTopupModalOpen, setTopupModalOpen] = useState<boolean>(false);

  const toggleTopupModal = () => {
    setTopupModalOpen(prev => !prev);
  };

  const currentDate = getFormattedDate(new Date(), OA_DATE_TIME_FORMAT_FE);

  const cardData = useMemo(() => [
    { title: 'Account Balance', amount: props?.data?.currentBalance ?? props?.data?.pendingBalance, date: currentDate },
    { title: 'Total Owed', amount: props?.data?.totalOwed, date: currentDate },
    { title: 'Total Paid out', amount: props?.data?.totalPaidOut, date: currentDate },
    // { title: 'Pending Balance', amount: props?.data?.pendingBalance, date: currentDate },
  ], [props?.data, currentDate]);

  return (
    <>
      <div className='d-flex justify-content-end mb-3'>
        <OAButton
          onClick={toggleTopupModal}
          label='Add Topup'
          className='btn-sm btn-active-primary'
        />
      </div>
      <div className='d-flex gap-4 mb-6'>
        <div style={{ flex: '0 0 50%' }}>
          <Row className='g-4'>
            {cardData.map((card, index) => (
              <Col key={index} xs={6}>
                <Card
                  style={{
                    height: '120px',
                    borderRadius: '8px',
                    background: '#FFF',
                    boxShadow: '0 0 20px 0 rgba(76, 87, 125, 0.02)',
                  }}
                >
                  <Card.Body>
                    <div className='d-flex justify-content-between align-items-start'>
                      <div>
                        <div className='text-muted fw-semibold fs-6 mb-6'>{card.title}</div>
                        <div className='fw-bold fs-2'>{card.amount}</div>
                        <div className='text-muted fw-medium' style={{ fontSize: '12px' }}>
                          {card.date}
                        </div>
                      </div>
                    </div>
                  </Card.Body>
                </Card>
              </Col>
            ))}
          </Row>
        </div>
     {!props?.data?.ledgerType && <div style={{ flex: '0 0 50%' }}>
        <Card
          style={{
            height: '258px',
            borderRadius: '8px',
            background: '#FFF',
            boxShadow: '0 0 20px 0 rgba(76, 87, 125, 0.02)',
          }}
        >
          <Card.Body className='p-0'>
            <div className=' card-header px-6 py-4'>
              <h3 className='m-0'>Customer breakdown</h3>
            </div>
            <div className='px-6 py-4'>
              <table className='table table-row-bordered table-row-gray-100 align-middle gs-0 gy-3'>
                <thead>
                  <tr className='fw-bold text-muted'>
                    <th className='min-w-150px'>Customer Name</th>
                    <th className='min-w-120px'>Transaction Count</th>
                    <th className='min-w-120px'>Total Transaction Amount</th>
                  </tr>
                </thead>
                <tbody>
                  {props?.data?.customerBreakdown?.length > 0 ? (
                    props?.data?.customerBreakdown?.map((customer: any, index: number) => (
                      <tr key={index}>
                        <td className='text-dark fw-bold'>{customer.customerName}</td>
                        <td className='text-dark'>
                          {customer?.transactionCount}
                        </td>
                        <td className='text-dark'>
                          ₹{customer?.totalAmount?.toLocaleString('en-IN')}
                        </td>
                      </tr>
                    ))
                  ) : (
                    <tr>
                      <td colSpan={3} className='text-center text-muted'>
                        No customer data available
                      </td>
                    </tr>
                  )}
                </tbody>
              </table>
            </div>
          </Card.Body>
        </Card>
      </div>}
      </div>

      <OAModalComponent
        className='topup-modal'
        show={isTopupModalOpen}
        onHide={toggleTopupModal}
        header={{
          title: 'Add Topup',
          closeButton: true
        }}
        body={{
          content: <AddTopupForm onHide={toggleTopupModal} onSuccess={props?.onTopupSuccess} />
        }}
      />
    </>
  );
};

export default CustomerLedgerCards;